import React, { useState } from "react";
import "./App.css";
import ScoreBoard from "./components/ScoreBoard";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <ScoreBoard />
      </header>
    </div>
  );
}

export default App;
